import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/children/:id/grades',
      name: 'child-grades',
      component: () => import('../views/children/Grades.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/children/:id/attendance',
      name: 'child-attendance',
      component: () => import('../views/children/Attendance.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/fees',
      name: 'fees',
      component: () => import('../views/Fees.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('../views/Messages.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/documents',
      name: 'documents',
      component: () => import('../views/Documents.vue'),
      meta: { requiresAuth: true },
    },
  ],
});

// Navigation guard
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();

  // Handle subdomain query param on login page — store it before proceeding
  if (to.name === 'login') {
    const subdomainFromQuery = to.query['x-subdomain'] as string | undefined;
    if (subdomainFromQuery) {
      localStorage.setItem('currentSubdomain', subdomainFromQuery);
    }
  }

  const requiresAuth = to.meta.requiresAuth !== false;

  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login', query: to.fullPath !== '/dashboard' ? { redirect: to.fullPath } : {} });
    return;
  }

  if (to.name === 'login' && authStore.isAuthenticated) {
    next({ name: 'dashboard' });
    return;
  }

  next();
});

export default router;
